import { VerticalType } from './verticalType.enum';

export const VERTICAL_LABEL_KEY: Record<VerticalType, string> = {
  [VerticalType.Transfer]: 'transfer',
  [VerticalType.MechanicalInspection]: 'mechanical_inspection',
  [VerticalType.VehicleWash]: 'vehicle_wash',
  [VerticalType.Refueling]: 'refueling',
  [VerticalType.PreTechnicalInspection]: 'pre_technical_inspection',
  [VerticalType.LongDistanceTransfer]: 'long_distance_transfer',
  [VerticalType.TechnicalInspection]: 'technical_inspection',
  [VerticalType.VehicleInsurance]: 'vehicle_insurance',
  [VerticalType.VehicleDataCollection]: 'vehicle_data_collection',
  [VerticalType.Accessory]: 'accessory',
  [VerticalType.Valet]: 'valet',
  [VerticalType.Tyres]: 'tyres',
  [VerticalType.Formalities]: 'formalities',
  [VerticalType.Parking]: 'parking',
  [VerticalType.ReplacementVehicle]: 'replacement_vehicle',
  [VerticalType.TowTruck]: 'tow_truck',
  [VerticalType.WhateverYouWant]: 'whatever_you_want',
  [VerticalType.VehicleStorage]: 'vehicle_storage',
  [VerticalType.Battery]: 'battery',
  [VerticalType.InternalPickup]: 'internal_pickup',
  [VerticalType.InternalReturn]: 'internal_return',
  [VerticalType.InternalTransfer]: 'internal_transfer',
  [VerticalType.Overdrafts]: 'overdrafts',
};
